import { AgentPanel } from './AgentPanel';
import { meta } from './meta';

export { meta };

export default function VoiceAssistant() {
  return <AgentPanel />;
}
